// @ts-nocheck
import { HtmlClassSwitch } from "./Dom";
import { ControlMode, WebPageComponent } from "./WebSite.Page.Component";

export class FormField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.touched = false;
  }

  addValueChangedHandler(source) {
    source.addEventListener(
      "change",
      (event) => {
        this.touched = true;
        this.validate();
      }
    );
  }

  addBlurHandler(source) {
    source.addEventListener(
      "blur",
      (event) => {
        if (event.relatedTarget === null || !this.element.contains(event.relatedTarget)) {
          this.touched = true;
          this.validate();
        }
      }
    );
  }

  checkInput(problemTarget) {
    const value = this.getValue();

    if (value === null && !this.optional)
      problemTarget.addProblem(this, this.element.dataset.EmptyValueMessage);
  }

  validate(problemTarget = null) {
    if (this.mode === ControlMode.edit) {
      if (problemTarget === null)
        problemTarget = this.parentComponent;

      if (typeof problemTarget.addProblem === "function") {
        problemTarget.clearProblems(this);
        this.checkInput(problemTarget);
      }
    }
  }

  load(value) {
    this.setValue(value);
    this.validate();
  }

  save() {
    return this.getValue();
  }

  setInputDisabled(disabled) {
    console.warn("Missing `setInputDisabled` implementation for: " + this.constructor.name);
  }

  setInputName(name) {
    console.warn("Missing `setInputName` implementation for: " + this.constructor.name);
  }

  setName(name) {
    this.updateUri(name);

    this.element.dataset.HierarchicalName = this.element.dataset.HierarchicalName.replace(/[^/]*$/, name);
    this.element.dataset.Name = name;

    this.setInputName(this.element.dataset.HierarchicalName);
  }

  updateUri(name) {
  }

  get name() {
    return this.element.dataset.Name;
  }

  get optional() {
    return this.element.dataset.Optional === "true";
  }

  get value() {
    return this.getValue();
  }

  set value(value) {
    this.setValue(value);
  }
}

export class DefaultFormField extends FormField {
  constructor(element) {
    super(element);

    this.input = null;
    this.focused = new HtmlClassSwitch(this.element, "Focus");
  }

  bind() {
    if (this.input !== null) {
      this.input.addEventListener("focus", (event) => { this.focused.setStatus(true); });
      this.input.addEventListener("blur", (event) => { this.focused.setStatus(false); });
    }
  }

  addEventListener(event, handler) {
    if (this.input !== null)
      this.input.addEventListener(event, handler);
  }

  focus() {
    if (this.input !== null)
      this.input.focus();
  }

  setInputDisabled(disabled) {
    if (this.input !== null)
      this.input.disabled = disabled;
  }

  setInputName(name) {
    if (this.input !== null)
      this.input.name = name;
  }

  getValue() {
    return this.input.value !== "" ? this.input.value : null;
  }

  setValue(value) {
    const fieldValue = value !== null ? value : "";

    if (fieldValue !== this.input.value) {
      this.input.value = fieldValue;
      this.input.dispatchEvent(new Event("change"));
    }
  }
}
